// modules.ts
import type { Template } from "@/types/Template";

// ---- Import all template folders ----
import * as SQ_AR_2_0 from "./SQ/AR_2.0";
import * as LA_AR_2_50 from "./LA/AR_2.50";
import * as LA_AR_2_55 from "./LA/AR_2.55";
import * as LA_AR_2_67 from "./LA/AR_2.67";
import * as LA_AR_2_80 from "./LA/AR_2.80";

// Uncomment or import PO ARs
import * as PO_AR_1_33 from "./PO/AR_1.33";
import * as PO_AR_1_40 from "./PO/AR_1.40";
import * as PO_AR_1_43 from "./PO/AR_1.43";
import * as PO_AR_1_50 from "./PO/AR_1.50";
import * as PO_AR_1_57 from "./PO/AR_1.57";
import * as PO_AR_1_60 from "./PO/AR_1.60";

import * as MF_AR_1_00 from "./ΜF/AR_1.00"; // square
import * as MF_AR_2_0 from "./ΜF/AR_2.0"; // horizontal 



// ---- Group templates by AR version ----
export const modules: Record<string, Record<string, Template[]>> = {

    "2.00": SQ_AR_2_0,
    "2.50": LA_AR_2_50,
    "2.55": LA_AR_2_55,
    "2.67": LA_AR_2_67,
    "2.80": LA_AR_2_80,
    "1.33": PO_AR_1_33,
    "1.40": PO_AR_1_40,
    "1.43": PO_AR_1_43,
    "1.50": PO_AR_1_50,
    "1.57": PO_AR_1_57,
    "1.60": PO_AR_1_60,
    // Montage templates
    "1.00": MF_AR_1_00, // square
    "2.0": MF_AR_2_0, // merge with existing 2.00 templates
   
};

// ---- Build allTemplatesMap including AR version in the key ----
export const allTemplatesMap: Record<string, Template[]> = {};

Object.entries(modules).forEach(([arVersion, templatesGroup]) => {
    Object.values(templatesGroup).forEach((templates: Template[]) => {

        templates.forEach((template) => {
            const openAR = arVersion; // use folder AR
            const countH = template.slots.filter((s) => s.width > s.height).length;
            const countV = template.slots.filter((s) => s.width < s.height).length;


            const key = `${openAR}_${String(countH + countV).padStart(2, "0")}_H${countH}_V${countV}`;

            if (!allTemplatesMap[key]) {
                allTemplatesMap[key] = [];
            }
            allTemplatesMap[key].push({
                ...template,
                thumbnail: `${process.env.PUBLIC_URL}${template.thumbnail}`,
                name: template.name || template.id,
                texts: template.texts || [], // ensure new templates have texts array
            });
        });
    });
});


